import { updateData, updateNone } from 'crustate';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var syncQuote = function syncQuote(data) {
  return {
    tag: QUOTE_SYNC,
    data: data
  };
};
var addItem = function addItem(params, qty) {
  return {
    tag: QUOTE_ADD_ITEM_REQUEST,
    buyRequest: params.buyRequest,
    bundleOptions: params.bundleOptions,
    customOptions: params.customOptions,
    qty: qty
  };
};
var removeQuoteItem = function removeQuoteItem(itemBuyRequest) {
  return {
    tag: QUOTE_REMOVE_ITEM_REQUEST,
    itemBuyRequest: itemBuyRequest
  };
};
var updateQuoteItemQty = function updateQuoteItemQty(itemBuyRequest, qty) {
  return {
    tag: QUOTE_UPDATE_ITEM_REQUEST,
    itemBuyRequest: itemBuyRequest,
    qty: qty
  };
};
var setEmail = function setEmail(email) {
  return {
    tag: QUOTE_SET_EMAIL_REQUEST,
    email: email
  };
};
var setShippingAddress = function setShippingAddress(address) {
  return {
    tag: QUOTE_SET_SHIPPING_ADDRESS_REQUEST,
    type: "setShippingAddress",
    address: address
  };
};
var setBillingAddress = function setBillingAddress(address) {
  return {
    tag: QUOTE_SET_BILLING_ADDRESS_REQUEST,
    type: "setBillingAddress",
    address: address
  };
};
var setAddresses = function setAddresses(email, billing, shipping, shipToSameAddress) {
  return {
    tag: QUOTE_SET_ADDRESSES_REQUEST,
    email: email,
    billing: billing,
    shipping: shipping,
    shipToSameAddress: shipToSameAddress
  };
};
var placeOrder = function placeOrder(params) {
  return _extends({}, params || Object.freeze({}), {
    tag: QUOTE_PLACE_ORDER_REQUEST
  });
};
var setCoupon = function setCoupon(code) {
  return {
    tag: QUOTE_SET_COUPON_REQUEST,
    code: code
  };
};
var setQuotePaymentMethodStripe = function setQuotePaymentMethodStripe() {
  return {
    tag: QUOTE_SET_PAYMENT_METHOD_STRIPE_REQUEST
  };
};
var loadQuote = function loadQuote() {
  return {
    tag: QUOTE_LOAD_REQUEST
  };
};
var QUOTE_SYNC = "quote/sync";
var QUOTE_INIT_REQUEST = "quote/init/request";
var QUOTE_INIT_RESPONSE = "quote/init/response";
var QUOTE_LOAD_REQUEST = "quote/load/request";
var QUOTE_LOAD_RESPONSE = "quote/load/response";
var QUOTE_ADD_ITEM_REQUEST = "quote/add_item/request";
var QUOTE_ADD_ITEM_RESPONSE = "quote/add_item/response";
var QUOTE_REMOVE_ITEM_REQUEST = "quote/remove_item/request";
var QUOTE_REMOVE_ITEM_RESPONSE = "quote/remove_item/response";
var QUOTE_UPDATE_ITEM_REQUEST = "quote/update_item/request";
var QUOTE_UPDATE_ITEM_RESPONSE = "quote/update_item/response";
var QUOTE_SET_SHIPPING_ADDRESS_REQUEST = "quote/set_shipping_address/request";
var QUOTE_SET_SHIPPING_ADDRESS_RESPONSE = "quote/set_shipping_address/response";
var QUOTE_SET_BILLING_ADDRESS_REQUEST = "quote/set_billing_address/request";
var QUOTE_SET_BILLING_ADDRESS_RESPONSE = "quote/set_billing_address/response";
var QUOTE_SET_EMAIL_REQUEST = "quote/set_email/request";
var QUOTE_SET_EMAIL_RESPONSE = "quote/set_email/response";
var QUOTE_SET_ADDRESSES_REQUEST = "quote/set_addresses/request";
var QUOTE_SET_ADDRESSES_RESPONSE = "quote/set_addresses/response";
var QUOTE_PLACE_ORDER_REQUEST = "quote/place_order/request";
var QUOTE_PLACE_ORDER_RESPONSE = "quote/place_order/response";
var QUOTE_SET_COUPON_REQUEST = "quote/set_coupon/request";
var QUOTE_SET_COUPON_RESPONSE = "quote/set_coupon/response";
var QUOTE_SET_PAYMENT_METHOD_STRIPE_REQUEST = "quote/set_payment_method_stripe/request";
var QUOTE_SET_PAYMENT_METHOD_STRIPE_RESPONSE = "quote/set_payment_method_stripe/response";
var QUOTE_SET_DISCOUNT_CODE_REQUEST = "quote/set_discount_code/request";
var QUOTE_SET_DISCOUNT_CODE_RESPONSE = "quote/set_discount_code/response";
var QUOTE_REMOVE_DISCOUNT_CODE_REQUEST = "quote/remove_discount_code/request";
var QUOTE_REMOVE_DISCOUNT_CODE_RESPONSE = "quote/remove_discount_code/response";
var QuoteModel = {
  id: "quote",
  init: function init() {
    return updateData({
      state: "LOADING"
    }, {
      tag: QUOTE_INIT_REQUEST
    });
  },
  update: function update(state, msg) {
    switch (msg.tag) {
      case QUOTE_LOAD_REQUEST:
        return updateData({
          state: "LOADING"
        }, msg);
      case QUOTE_LOAD_RESPONSE:
        if (msg.data) {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Failed to load quote");
      case QUOTE_SYNC:
        if (msg.data) {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        return updateNone();
      case QUOTE_INIT_RESPONSE:
        if (msg.data) {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        return updateNone();
      case QUOTE_ADD_ITEM_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "ADDING_ITEM",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_ADD_ITEM_RESPONSE:
        if (state.state === "ADDING_ITEM") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_UPDATE_ITEM_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "UPDATING_ITEM",
            data: state.data,
            processingItem: msg.itemBuyRequest
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_UPDATE_ITEM_RESPONSE:
        if (state.state === "UPDATING_ITEM") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_REMOVE_ITEM_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "REMOVING_ITEM",
            data: state.data,
            processingItem: msg.itemBuyRequest
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_REMOVE_ITEM_RESPONSE:
        if (state.state === "REMOVING_ITEM") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_BILLING_ADDRESS_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_ADDRESS",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_BILLING_ADDRESS_RESPONSE:
        if (state.state === "SETTING_ADDRESS") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_SHIPPING_ADDRESS_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_ADDRESS",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_SHIPPING_ADDRESS_RESPONSE:
        if (state.state === "SETTING_ADDRESS") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_EMAIL_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_EMAIL",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_EMAIL_RESPONSE:
        if (state.state === "SETTING_EMAIL") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_ADDRESSES_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_ADDRESS",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_ADDRESSES_RESPONSE:
        if (state.state === "SETTING_ADDRESS") {
          if (msg.errors) {
            return updateData({
              state: "LOADED",
              data: msg.data,
              errors: msg.errors
            });
          }
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_COUPON_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_COUPON",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_COUPON_RESPONSE:
        if (state.state === "SETTING_COUPON") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_PLACE_ORDER_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "PLACING_ORDER",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_PLACE_ORDER_RESPONSE:
        if (state.state === "PLACING_ORDER") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_PAYMENT_METHOD_STRIPE_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_PAYMENT_METHOD",
            data: state.data
          }, msg);
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_PAYMENT_METHOD_STRIPE_RESPONSE:
        if (state.state === "SETTING_PAYMENT_METHOD") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        throw new Error("Invalid state transition");
      case QUOTE_SET_DISCOUNT_CODE_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "SETTING_DISCOUNT_CODE",
            data: state.data
          }, msg);
        }
        console.error("Invalid state transition");
        return updateNone();
      case QUOTE_REMOVE_DISCOUNT_CODE_REQUEST:
        if (state.state === "LOADED") {
          return updateData({
            state: "REMOVING_DISCOUNT_CODE",
            data: state.data
          }, msg);
        }
        console.error("Invalid state transition");
        return updateNone();
      case QUOTE_SET_DISCOUNT_CODE_RESPONSE:
        if (state.state === "SETTING_DISCOUNT_CODE") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        console.error("Invalid state transition");
        return updateNone();
      case QUOTE_REMOVE_DISCOUNT_CODE_RESPONSE:
        if (state.state === "REMOVING_DISCOUNT_CODE") {
          return updateData({
            state: "LOADED",
            data: msg.data
          });
        }
        console.error("Invalid state transition");
        return updateNone();
      default:
    }
  }
};

export { QUOTE_ADD_ITEM_REQUEST, QUOTE_ADD_ITEM_RESPONSE, QUOTE_INIT_REQUEST, QUOTE_INIT_RESPONSE, QUOTE_LOAD_REQUEST, QUOTE_LOAD_RESPONSE, QUOTE_PLACE_ORDER_REQUEST, QUOTE_PLACE_ORDER_RESPONSE, QUOTE_REMOVE_DISCOUNT_CODE_REQUEST, QUOTE_REMOVE_DISCOUNT_CODE_RESPONSE, QUOTE_REMOVE_ITEM_REQUEST, QUOTE_REMOVE_ITEM_RESPONSE, QUOTE_SET_ADDRESSES_REQUEST, QUOTE_SET_ADDRESSES_RESPONSE, QUOTE_SET_BILLING_ADDRESS_REQUEST, QUOTE_SET_BILLING_ADDRESS_RESPONSE, QUOTE_SET_COUPON_REQUEST, QUOTE_SET_COUPON_RESPONSE, QUOTE_SET_DISCOUNT_CODE_REQUEST, QUOTE_SET_DISCOUNT_CODE_RESPONSE, QUOTE_SET_EMAIL_REQUEST, QUOTE_SET_EMAIL_RESPONSE, QUOTE_SET_PAYMENT_METHOD_STRIPE_REQUEST, QUOTE_SET_PAYMENT_METHOD_STRIPE_RESPONSE, QUOTE_SET_SHIPPING_ADDRESS_REQUEST, QUOTE_SET_SHIPPING_ADDRESS_RESPONSE, QUOTE_SYNC, QUOTE_UPDATE_ITEM_REQUEST, QUOTE_UPDATE_ITEM_RESPONSE, QuoteModel, addItem, loadQuote, placeOrder, removeQuoteItem, setAddresses, setBillingAddress, setCoupon, setEmail, setQuotePaymentMethodStripe, setShippingAddress, syncQuote, updateQuoteItemQty };
//# sourceMappingURL=index.esm.js.map
